import { cssGradient } from "../lib/colorscale.js";
import { COLORSCALES } from "../lib/palettes.js";
import { publishedAt } from "../lib/producer.js";

function fmtValid(ref, hour) {
  const d = new Date(new Date(ref).getTime() + hour * 3600_000);
  return d.toISOString().slice(5, 16).replace("T", " ") + "Z";
}

export default function Timeline({ manifest, hour, param, playing, showAlerts, showObs, loading, onHour, onParam, onPlay, onShowAlerts, onShowObs, onDownload, downloading }) {
  const published = publishedAt(manifest);
  const spec = manifest.parameters.find((p) => p.name === param) || manifest.parameters[0];
  const highlight = new Set(manifest.highlight_parameters || []);
  const sorted = [...manifest.parameters].sort((a, b) => (highlight.has(b.name) - highlight.has(a.name)) || a.label.localeCompare(b.label));
  return (
    <div className="chaos-timeline">
      <div className="chaos-tl-row">
        <button type="button" className="btn btn-secondary btn-sm" onClick={onPlay} aria-label={playing ? "Pause" : "Play"}>{playing ? "❚❚" : "▶"}</button>
        <div className="chaos-tl-time">
          <strong>f{String(hour).padStart(3, "0")}</strong>
          <span className="muted">{fmtValid(manifest.reference_time, hour)}</span>
        </div>
        <input className="wxr chaos-tl-slider" type="range" min={0} max={manifest.horizon_hours} step={1} value={hour} onChange={(e) => onHour(Number(e.target.value))} />
        {loading && <span className="chaos-spin" aria-label="loading" />}
      </div>
      <div className="chaos-tl-row">
        <select className="select chaos-tl-param" value={spec.name} onChange={(e) => onParam(e.target.value)}>
          {sorted.map((p) => (
            <option key={p.name} value={p.name}>
              {highlight.has(p.name) ? "● " : ""}{p.label}{p.local_use ? " (local use)" : ""}
            </option>
          ))}
        </select>
        <div className="chaos-legend">
          <div className="chaos-legend-bar" style={{ background: cssGradient(COLORSCALES, spec.colorscale, 0, 1) }} />
          <div className="chaos-legend-ticks">
            <span>{spec.display_range[0]}</span>
            <span>{spec.units}</span>
            <span>{spec.display_range[1]}</span>
          </div>
        </div>
        <label className="chaos-toggle"><input type="checkbox" checked={showAlerts} onChange={(e) => onShowAlerts(e.target.checked)} /> Alerts</label>
        {manifest.observations && <label className="chaos-toggle"><input type="checkbox" checked={showObs} onChange={(e) => onShowObs(e.target.checked)} /> Obs</label>}
        <button type="button" className="btn btn-primary btn-sm" onClick={onDownload} disabled={downloading}>{downloading ? "Preparing…" : "Download zip"}</button>
      </div>
      <div className="chaos-tl-meta muted">
        {manifest.name} · {manifest.issue_id} · {manifest.files.length} GRIB2 files · {(manifest.total_bytes / 1e6).toFixed(1)} MB ·
        grid {manifest.grid.ni}×{manifest.grid.nj} @ {manifest.grid.resolution_deg}° · {manifest.parameters.length} parameters ·
        {" "}{manifest.alerts.count} alerts{manifest.observations ? ` · ${manifest.observations.count} observations` : ""}
        {published && <div className="chaos-published">Published to {published}</div>}
      </div>
    </div>
  );
}
